import { defineStore } from 'pinia'
import { ref } from 'vue'

// 下载进度状态管理
export const useDownloadProgressStore = defineStore('downloadProgress', () => {
  // 下载进度
  const progress = ref(0)
  // 是否显示下载进度条
  const visible = ref(false)
  // 下载文件标题
  const title = ref('')
  // 正在下载的文件URL
  const currentDownloadUrl = ref('')
  // 是否有下载任务正在进行
  const isDownloading = ref(false)

  // 开始下载，初始化下载状态
  const startDownload = (fileTitle: string, url: string) => {
    progress.value = 0
    visible.value = true
    title.value = fileTitle
    currentDownloadUrl.value = url
    isDownloading.value = true
  }

  // 更新下载进度
  const updateProgress = (value: number) => {
    progress.value = value
  }

  // 完成下载
  const completeDownload = () => {
    progress.value = 100

    // 延迟关闭通知
    setTimeout(() => {
      visible.value = false
      isDownloading.value = false
    }, 1500)
  }

  // 手动关闭下载进度条
  const closeProgress = () => {
    visible.value = false
  }

  // 下载失败
  const downloadFailed = () => {
    isDownloading.value = false
    visible.value = false
  }

  return {
    progress,
    visible,
    title,
    currentDownloadUrl,
    isDownloading,
    startDownload,
    updateProgress,
    completeDownload,
    closeProgress,
    downloadFailed,
  }
})

// 导出钩子函数便于在组件外部使用
export const useDownloadProgressStoreHook = () => {
  return useDownloadProgressStore()
}
